import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/fund/paypal_logo.png'
import _imports_1 from '@/assets/image/fund/icon_lock_blue.png'
import _imports_2 from '@/assets/image/fund/icon_circle.png'
import _imports_3 from '@/assets/image/fund/icon_exclamation_mark.png'
import _imports_4 from '@/assets/image/fund/icon_lock_paypal.png'


const _withScopeId = n => (_pushScopeId("data-v-d0f7923e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "credit-card-pay" }
const _hoisted_2 = { class: "credit-card-pay-dialog-title" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "paypal-icon" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "paypal-tip flex-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "credit-card-pay-dialog" }
const _hoisted_10 = { class: "credit-card-pay-item" }
const _hoisted_11 = { style: {"word-break":"break-word"} }
const _hoisted_12 = { class: "credit-card-pay-item" }
const _hoisted_13 = { class: "credit-card-pay-item" }
const _hoisted_14 = {
  key: 0,
  class: "credit-card-pay-item rel"
}
const _hoisted_15 = {
  key: 0,
  class: "abs",
  style: {"left":"160px","bottom":"-20px","color":"#333333"}
}
const _hoisted_16 = {
  key: 1,
  class: "credit-card-pay-item rel"
}
const _hoisted_17 = {
  key: 0,
  class: "tips",
  style: {"left":"160px","bottom":"-20px","color":"#333333"}
}
const _hoisted_18 = { class: "pay-btn" }
const _hoisted_19 = {
  key: 0,
  class: "credit-card-pay-loading abs"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    class: "animation"
  })
], -1))
const _hoisted_21 = { class: "credit-card-pay-loading-title" }
const _hoisted_22 = { class: "credit-card-pay-loading-text" }
const _hoisted_23 = {
  key: 1,
  class: "loading-img"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "credit-card-pay-loading-title" }
const _hoisted_26 = { class: "credit-card-pay-loading-text" }
const _hoisted_27 = { class: "credit-card-pay-btn" }
const _hoisted_28 = {
  key: 2,
  class: "loading-img"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    class: "animation"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "",
    class: "abs lock-icon"
  })
], -1))
const _hoisted_30 = { class: "credit-card-pay-loading-title" }
const _hoisted_31 = { class: "credit-card-pay-loading-text" }

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import { createPaypalWalletApi, getPalpalTokenApi, walletPaypalCaptureApi, saveCreditCardApi, createPaypalCreditPayApi, authorizeApi, createVipPaypalCreditCardApi, membershipPaypalCaptureApi, getClientIdApi, walletPaypalCardCaptureApi, getMembershipRechargeExchangeRateKrw2Usd, walletOrderPaypalSetupTokenCreate, walletOrderPaypalPaymentTokenCreate, membershipOrderCreateCreditFree } from '@/apis/pay'
import { useStore } from 'vuex'
import { ArrowRight, CloseBold } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { setTimeout } from 'timers'
import { rate, floatingRate, floatingRateKrw } from '@/util/useYan'
import { isKO, isMultiStore } from '@/store'
import { Site } from '@/common/const'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: ''
  },
  membershipParams: {
    type: Object,
    default: () => { return {} }
  },
  currencyCode: {
    type: String,
    default: undefined
  },
  paypalAmount: {
    type: Number,
    default: 0
  }
},
  emits: ['update:visible', 'submit', 'error'],
  setup(__props, { emit }) {

const props = __props
const loading = ref(false)
const loadingStatus = ref(1) // 1 加载中 2加载失败 3 支付中

const membershipPrice = computed(() => {
  return props.membershipParams?.membershipTemplatePrice?.trialFlag ? props.membershipParams.membershipTemplatePrice?.trialPrice : props.membershipParams.membershipTemplatePrice?.discountActualPrice || ''
})
const close = () => {
  emit('update:visible', false)
}

const store = useStore()
let isRequest = false
let apiTimer: any = null
const createButton = () => {
  if (isRequest) return
  isRequest = true
  loading.value = true
  clearTimeout(apiTimer)
  getClientIdApi().then((res: any) => {
    if (!res.success) {
      isRequest = false
      apiTimer = setTimeout(() => {
        createButton()
      }, 2000)
      return
    }
    // const clientId = 'AY5JcSLlu4KsfwDQz2Wd0SnZ5OpsNvwF55xgM4umHeIwGbUmPvb4aIEugWzVdSUz8w0IvjJtGTIpn_aO'
    const clientId = res.data
    const url = 'https://www.paypal.com/sdk/js?client-id=' + clientId + '&currency=JPY&components=buttons,hosted-fields,card-fields,funding-eligibility&intent=capture'
    loadScript(url, priceChangeButton)
  }).catch(() => {
  })
}
const loadScript = (url: string, callback: () => void) => {
  const script: any = document.createElement('script')
  if (script.readyState) {
    // IE
    script.onreadystatechange = () => {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
        loading.value = false
        console.log('加载完成！')
        callback()
      }
    }
  } else {
    // 其他浏览器
    script.onload = () => {
      callback()
      loading.value = false
      console.log('加载完成！')
    }
  }
  script.src = url
  getPalpalTokenApi({}).then((res: any) => {
    if (!res.success) {
      setTimeout(() => {
        loadScript(url, callback)
      }, 2000)
      return
    }
    script.setAttribute('data-client-token', res.data)
    document.body.appendChild(script)
  })
}
const paypalPrice = ref(props.paypalAmount ?? '')
const inputPrice: any = (row: any) => {
  paypalPrice.value = (paypalPrice.value.toString().match(/^[1-9]\d{0,8}/g) && paypalPrice.value.toString().match(/^[1-9]\d{0,8}/g)[0]) || ''
}

const trialDiscount = computed(() => props.membershipParams?.membershipTemplatePrice?.trialDiscount)
const creditFiledResult = ref({})
let hf: any = {}
const priceChangeButton = () => {
  const paypal = (window as any).paypal
  // 0元支付，绑卡逻辑
  if (trialDiscount.value === -2) {
    const style = {
      input: {
        'font-size': '14px',
        'line-height': '36px',
        outline: 'none',
        padding: '0 5px',
        'border-color': 'transparent',
        'box-shadow': 'none'
      },
      ':focus': {
        color: '#000'
      },
      '.invalid': {
        color: '#d9360b',
        border: 'none'
      }
    }
    const cardFields = paypal.CardFields({
      createVaultSetupToken: async () => {
        const res = await walletOrderPaypalSetupTokenCreate()
        return res.data
      },
      onApprove: async (data: any) => {
        const result = await walletOrderPaypalPaymentTokenCreate(data.vaultSetupToken)
        creditFiledResult.value = result.data
      },
      onError: (error: any) => {
        console.log('Error:', error)
      },
      style
    })

    console.log(cardFields, 'cardFields')

    if (cardFields.isEligible()) {
      cardFields.NumberField({ placeholder: t('仅限数字') }).render('#card-number')
      cardFields.ExpiryField({ placeholder: t('仅限数字，例：05/2022') }).render('#expiration-date')
      cardFields.CVVField({ placeholder: t('仅限输入3-4位数字安全码') }).render('#cvv')
    } else {
    }
    hf = cardFields
  } else {
    if (paypal.HostedFields.isEligible() === true) {
      paypal.HostedFields.render({
        createOrder: function (data: any, actions: any) {
          // logic to return an order ID from your server
          if (props.type === 'recharge') {
            return createPaypalWalletApi({
              originCurrencyCode: 'JPY',
              originRechargeAmount: paypalPrice.value,
              allIncludeFlag: !!props.paypalAmount
            }).then(res => {
              return res.data.payPalOrderId
            }).catch(() => {
              // 创建订单失败会卡在弹窗无法进行下次操作，关闭弹窗重新操作
              ElMessage.warning(t('支付失败，请重新操作！'))
              // close()
              // loading.value = true
              // loadingStatus.value = 2
            })
          } else {
            return createVipPaypalCreditCardApi(props.membershipParams).then((res: any) => {
              return res.data.orderId
            }).catch(() => {
              // 创建订单失败会卡在弹窗无法进行下次操作，关闭弹窗重新操作
              ElMessage.warning(t('支付失败，请重新操作！'))
              // loading.value = true
              // loadingStatus.value = 2
              // close()
            })
          }
        },
        styles: {
          input: {
            'font-size': '14px',
            'font-family': 'Product Sans'
          },
          ':focus': {
            color: 'black'
          },
          '.invalid': {
            color: '#FF0000'
          }
        },
        fields: {
          number: {
            selector: '#card-number',
            placeholder: t('仅限数字')
          },
          cvv: {
            selector: '#cvv',
            placeholder: t('仅限输入3-4位数字安全码')
          },
          expirationDate: {
            selector: '#expiration-date',
            placeholder: t('仅限数字，例：05/2022')
          }
        }
      }).then(function (hf2: any) {
        hf = hf2
      }).catch(() => {
        document.querySelector('#card-number') && (document!.querySelector('#card-number')!.innerHTML = '')
        document.querySelector('#cvv') && (document!.querySelector('#cvv')!.innerHTML = '')
        document.querySelector('#expiration-date') && (document!.querySelector('#expiration-date')!.innerHTML = '')
        priceChangeButton()
      })
    }
  }
}
let timer: any = null
const tryAgain = () => {
  clearTimeout(timer)
  clearTimeout(apiTimer)
  loadingStatus.value = 1
  const scriptEle = document.querySelector('[data-client-token]')
  if (scriptEle) {
    scriptEle.remove()
  }
  document.querySelector('#card-number') && (document!.querySelector('#card-number')!.innerHTML = '')
  document.querySelector('#cvv') && (document!.querySelector('#cvv')!.innerHTML = '')
  document.querySelector('#expiration-date') && (document!.querySelector('#expiration-date')!.innerHTML = '')
  createButton()
  timer = setTimeout(() => {
    loadingStatus.value === 1 && (loadingStatus.value = 2)
    clearTimeout(apiTimer)
  }, 10000)
}
tryAgain()
// 点击保存支付
const submit = () => {
  if (!paypalPrice.value && props.type === 'recharge') return

  // 0元支付，绑卡逻辑
  if (props.membershipParams?.membershipTemplatePrice?.trialDiscount === -2) {
    hf.getState().then((data: any) => {
      if (data.isFormValid) {
        loading.value = true
        loadingStatus.value = 3
        hf.submit().then(async (res: any) => {
          if (creditFiledResult.value) {
            // 支付订阅接口
            const res1 = await membershipOrderCreateCreditFree({ ...props.membershipParams, creditCardId: creditFiledResult.value })
            loading.value = false
            if (res1.success) {
              emit('update:visible', false)
              emit('submit')
            }
          } else {
            loading.value = false
          }
        }).catch((error: any) => {
          console.log('error', error)
          if (error.name === 'UNPROCESSABLE_ENTITY') {
            ElMessage.error(t('请检查卡信息是否有误'))
          } else {
            const errorList: any = {
              'The value of a field is either too short or too long.': t('您输入的值的长度对于目标字段来说可能太短或太长。 请再次输入正确的内容'),
              'The value of a field does not conform to the expected format.': t('您输入的值格式错误')
            }
            const message = (error.details && error.details[0] && errorList[error.details[0].description]) || error.message || t('错误请联系客服')
            ElMessage.error(message)
          }
          loading.value = false
        })
      }
    })
  } else {
    loading.value = true
    loadingStatus.value = 3
    hf && hf.submit({
      // pass the value of the checkbox when submitting the advanced credit and debit card payments instance
      vault: true
    }).then(function (payload: any) {
      // Make a call to capture the order (payload.orderId) here
      console.log('payload', payload)
      const params = props.type === 'recharge' ? {
        needValid: '',
        payPalOrderId: payload.orderId,
        creditPaymentOption: true,
        authorizationId: ''
      } : {
        ...props.membershipParams,
        creditCardOrderId: payload.orderId
      }
      const api = props.type === 'recharge' ? walletPaypalCardCaptureApi : membershipPaypalCaptureApi
      return api(params).then((res: any) => {
        console.log(t('提交成功'))
        if (res.success) {
          saveCreditCardApi({
            isDefault: false
          }).then((res: any) => {
            loading.value = false
            if (res.success) {
              emit('update:visible', false)
              emit('submit')
            }
          })
        } else {
          loading.value = false
        }
      }).catch((error: any) => {
        console.log(error)
      })
    }).catch((error: any) => {
      console.log('error', error)
      if (error.name === 'UNPROCESSABLE_ENTITY') {
        ElMessage.error(t('请检查卡信息是否有误'))
      } else {
        const errorList: any = {
          'The value of a field is either too short or too long.': t('您输入的值的长度对于目标字段来说可能太短或太长。 请再次输入正确的内容'),
          'The value of a field does not conform to the expected format.': t('您输入的值格式错误')
        }
        const message = (error.details && error.details[0] && errorList[error.details[0].description]) || error.message || t('错误请联系客服')
        ElMessage.error(message)
      }
      loading.value = false
    })
  }
}
const changePrice = (number: any): number => {
  const num = Number(number)
  return num * (1 - 0.034) / floatingRate
}
// 判断路由上币种为韩元且要要是日本站点
const isCurrencyCodeKRW = computed(() => {
  return props.currencyCode === 'KRW' && isMultiStore()
})
const ratePrice: any = computed(() => {
  const num = Number(paypalPrice.value)
  //   如果该账号支持韩元钱包，且用韩元钱包充值
  const floatingRateVal = isCurrencyCodeKRW.value ? floatingRateKrw.value : floatingRate.value
  let value = Math.floor(num * (1 - 0.034) / (Number(floatingRateVal)) * 100) / 100

  //   韩元取整，舍弃小数
  if (isCurrencyCodeKRW.value) {
    value = parseInt(String(value))
  }
  return value
})

const exchangeRateKrw2Usd = ref(0)
getMembershipRechargeExchangeRateKrw2Usd().then((res: any) => {
  exchangeRateKrw2Usd.value = res.data
})
const usPrice = computed(() => {
  const price = Math.ceil((membershipPrice.value / exchangeRateKrw2Usd.value) * 100) / 100
  return Number(price) > 0.01 ? Number(price) : '0.01'
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "custom-class": "credit-card-pay-dialog-content",
      "model-value": __props.visible,
      onClose: close,
      "append-to-body": "",
      "destroy-on-close": "",
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('绑定信用卡支付')), 1),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_unref(t)('由PayPal提供服务')), 1)
          ]),
          _createElementVNode("span", {
            class: "iconfont icon-guanbi2 icon",
            onClick: close
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('您填写的信息受到加密保护，请安心填写')), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass(_unref(trialDiscount) === -2 ? 'paypal-button credit-card' : 'paypal-button'),
                style: {"width":"100%"}
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('信用卡卡号')), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(_unref(trialDiscount) === -2 ? 'creditFiled' : 'filed'),
                    id: "card-number",
                    style: {"height":"36px"}
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('有効期限')), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(_unref(trialDiscount) === -2 ? 'creditFiled' : 'filed'),
                    id: "expiration-date",
                    style: {"height":"36px"}
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('信用卡安全码')), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(_unref(trialDiscount) === -2 ? 'creditFiled' : 'filed'),
                    id: "cvv",
                    style: {"height":"36px"}
                  }, null, 2)
                ]),
                (props.type === 'recharge')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('振込金額(日本円)')), 1),
                      _createVNode(_component_el_input, {
                        modelValue: paypalPrice.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paypalPrice).value = $event)),
                        onInput: inputPrice,
                        style: {"width":"300px"},
                        disabled: __props.paypalAmount
                      }, null, 8, ["modelValue", "disabled"]),
                      (!__props.paypalAmount)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString((_unref(isCurrencyCodeKRW) ? _unref(t)('预计到账KRW：X韩元') : _unref(t)('预计到账CNY：X元')).replace('X', _unref(ratePrice))), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (props.type === 'vip')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('支付金额(円)')), 1),
                      _createVNode(_component_el_input, {
                        modelValue: _unref(membershipPrice),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(membershipPrice) ? (membershipPrice).value = $event : null)),
                        disabled: "",
                        style: _normalizeStyle([{"width":"300px"}, _unref(trialDiscount) === -2 ? 'padding:0 0.375rem' : ''])
                      }, null, 8, ["modelValue", "style"]),
                      (_unref(isKO)())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                            _createTextVNode(_toDisplayString(_unref(t)('约合{dollar}美元',
                  { dollar: _unref(usPrice) })) + " ", 1),
                            _createElementVNode("span", null, "※[₩" + _toDisplayString(exchangeRateKrw2Usd.value) + "=1달러]환율에 따라 계산", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: "btn btn-cancel",
              onClick: close
            }, _toDisplayString(_unref(t)('取消')), 1),
            _createElementVNode("div", {
              class: _normalizeClass([{ disabled: props.type === 'recharge' && !paypalPrice.value }, 'btn btn-pay']),
              onClick: submit
            }, _toDisplayString(_unref(t)('立即支付')), 3)
          ])
        ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (loadingStatus.value === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('PayPal加载中，请稍等')), 1),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('由PayPal提供服务')), 1)
                  ], 64))
                : (loadingStatus.value === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('请求超时，请稍后重试')), 1),
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('由PayPal提供服务')), 1),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", {
                          class: "credit-card-pay-btn-cancel",
                          onClick: close
                        }, _toDisplayString(_unref(t)('取消')), 1),
                        _createElementVNode("div", {
                          class: "credit-card-pay-btn-again",
                          onClick: tryAgain
                        }, _toDisplayString(_unref(t)('再试一次')), 1)
                      ])
                    ]))
                  : (loadingStatus.value === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('支付中，请稍等')), 1),
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)('由PayPal提供服务')), 1)
                      ]))
                    : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})